/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const changeInventoryPolicy = createAsyncThunk(
  'products/changeInventoryPolicy',
  async ({ productId, variantId = 'default', inventoryPolicy }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const { data } = await sdk.products.changeInventoryPolicy(productId, variantId, inventoryPolicy);
      return data;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not change product inventory policy';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error product change inventory policy'), { error }, [
        'ChangeInventoryPolicyProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      changeInventoryPolicy.pending,
      (state, { meta }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = true;
          }
        });
      },
    )
    .addCase(
      changeInventoryPolicy.fulfilled,
      (state, { meta, payload }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = false;
            product.variants = payload.variants;
            product.defaultVariant = payload.defaultVariant;
          }
        });
      },
    )
    .addCase(
      changeInventoryPolicy.rejected,
      (state, { meta, error }) => {
        state.items.forEach((product) => {
          if (product._id === meta.arg.productId) {
            product.isBusy = false;
          }
        });
        state.error = error;
      },
    );
};
